import { useState } from 'react';
import { Link as RouterLink } from 'react-router';
import { Button, Field, Input, LINK_CLASS, Notice } from '@efira/ui';
import { fieldErrors, forgotPasswordSchema } from '@efira/contracts';

import { authClient } from '../auth/client';
import { AuthLayout } from './AuthLayout';

/**
 * Восстановление пароля.
 *
 * Та же логика неразглашения, что на регистрации: экран говорит «если такой
 * адрес зарегистрирован, письмо отправлено» - и говорит это всегда. Ответ
 * «такого адреса нет» превратил бы форму восстановления в проверялку почт.
 */
export function ForgotPasswordScreen() {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();

    const parsed = forgotPasswordSchema.safeParse({ email });

    if (!parsed.success) {
      setErrors(fieldErrors(parsed.error));
      return;
    }

    setErrors({});
    setLoading(true);

    await authClient.requestPasswordReset({
      email: parsed.data.email,
      redirectTo: `${window.location.origin}/reset-password`,
    });

    setLoading(false);
    // Результат не проверяется намеренно: экран одинаков и для
    // зарегистрированного адреса, и для незнакомого.
    setSent(true);
  }

  if (sent) {
    return (
      <AuthLayout
        title="Проверьте почту"
        footer={
          <RouterLink className={LINK_CLASS} to="/login">
            Вернуться ко входу
          </RouterLink>
        }
      >
        <Notice tone="success" title="Письмо отправлено">
          Если адрес <b>{email}</b> зарегистрирован, на него ушла ссылка для смены пароля. Ссылка
          действует ограниченное время и срабатывает один раз.
        </Notice>

        <p className="text-foreground/75 mt-4 text-sm">Письма нет? Загляните в спам.</p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Восстановление пароля"
      subtitle="Пришлём ссылку для установки нового пароля"
      footer={
        <RouterLink className={LINK_CLASS} to="/login">
          Вернуться ко входу
        </RouterLink>
      }
    >
      <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4">
        <Field label="Почта" error={errors['email']} required>
          {(props) => (
            <Input
              {...props}
              type="email"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              autoComplete="username"
              inputMode="email"
              autoFocus
              placeholder="you@example.com"
            />
          )}
        </Field>

        <div className="mt-2 flex flex-col gap-3">
          <Button type="submit" variant="primary" block loading={loading}>
            Прислать ссылку
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
}
